<template>

		<div class="pageBox" id="pageBox">
			<!--page start-->
			<div class="findPsw_box">

				<!--第1步-->
				<section class="" v-if="this.stepOne">
					<div class="center step_box">
						<img src="//images.jinku.com/newjk/h5/images/login/step_icon01.png" alt="">
					</div>

					<div class="step_one">
						<ul>
							<li class="clearfix "> <!--校验错误添加 alert_border 样式-->
								<input type="text" placeholder="手机号" class="inputItem fl" v-model.trim="mobile">
							</li>

							<li class="clearfix registerNumber">
								<div class="number_box fl re clearfix">
									<input type="text" class="ab number_input numberInputEvent" v-model.trim="smsCode">

									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
									<span class="line"></span>
								</div>
								<input type="button" value="发送验证码" class="sendCodeBtn fr" v-if="this.sendMsgBefore" v-on:click="sendMsg">
								<input type="button" value="发送完成" class="sendCodeBtn fr" v-if="this.sendMsgAfter">
							</li>
							<li class="formAlert" v-if="this.stepOneErrMsgShow">
								{{this.stepOneErrMsg}}
							</li>
						</ul>

						<div class="btnGroup">
							<a class="btnItem btnItem01 pointer " v-on:click="nextTwo">下一步</a><!--按钮可操作删除 disabled -->
						</div>

					</div>
				</section>

				<!--第2步-->
				<section v-if="this.stepTwo">
					<div class="center step_box">
						<img src="//images.jinku.com/newjk/h5/images/login/step_icon02.png" alt="">
					</div>

					<div class="step_two">
						<ul>
							<li class="re">
								<img src="//images.jinku.com/newjk/h5/images/login/icon02.png" class="icon ab">
								<input v-bind:type="this.pwdType" placeholder="新密码" class="inputItem fl" v-model.trim="newPwd">
								<span class="ab pointer pswToggle pswToggleEvent" v-on:click="showPwdNew"></span>
							</li>
						</ul>

						<div class="btnGroup">
							<a class="btnItem btnItem01 pointer " v-on:click="savePwdNew">保存</a><!--按钮可操作删除 disabled -->
						</div>

					</div>
				</section>

				<!--第3步-->
				<section v-if="this.stepThree">
					<div class="center step_box">
						<img src="//images.jinku.com/newjk/h5/images/login/step_icon03.png" alt="">
					</div>
					<div class="step_three">
						<div class="center">
							<img src="//images.jinku.com/newjk/h5/images/login/icon09.png" alt="" class="icon">
						</div>
						<div class="linkInfor center">
							若未自动跳转，请  <a href="/login" target="_blank">点击此处</a>
						</div>
					</div>
				</section>

			</div>
			<!--page end-->
		</div>

</template>

<script>
    import http from "../lib/http";
    import common from "../lib/common";

    export default {
        name: 'ResetPwd',
        data() {
            return {
                counter: 0,
                stepOne: true,
                stepTwo: false,
                stepThree: false,
				stepOneErrMsgShow: false,
				stepOneErrMsg: "",
                mobile: "",
				smsCode: "",
                sendMsgBefore: true,
                sendMsgAfter: false,
                newPwd: "",
                pwdType: "password",
            }
        },
        methods: {
            showPwdNew:function () {
                if (this.counter % 2 == 0) {
                    this.pwdType = "text";
                } else {
                    this.pwdType = "password";
                }
                this.counter++;
            },
            sendMsg:function () {
                const self = this;
                this.stepOneErrMsgShow = false;
                if (!/^1[3-9]\d{9}$/.test(this.mobile)){
                    this.stepOneErrMsg = "手机号码异常";
                    this.stepOneErrMsgShow = true;
                    return false;
                }
                //调用发送短信验证码接口
                http({method: "post", url: "/user/send-code", data: "code_source=3&user_mobile="+encodeURIComponent(this.mobile)+"&area_code="+encodeURIComponent('+86')}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){ //验证码发送完成
                        self.sendMsgBefore = false;
                        self.sendMsgAfter = true;
                    } else {
                        self.stepOneErrMsg = res.mess;
                        self.stepOneErrMsgShow = true;
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    self.stepOneErrMsg = "发送失败请稍后重试";
                    self.stepOneErrMsgShow = true;
                });
            },
            nextTwo:function () {
                const self = this;
                if (!/^1[3-9]\d{9}$/.test(this.mobile)){
                    this.stepOneErrMsg = "手机号码异常";
                    this.stepOneErrMsgShow = true;
                    return false;
                }
                if (!/\d{6}/.test(this.smsCode)){
                    this.stepOneErrMsg = "验证码异常";
                    this.stepOneErrMsgShow = true;
                    return false;
                }

                //ajax 调用登录接口
                http({method: "post", url: "/user/upd-pwd-one", data: "area_code="+encodeURIComponent('+86')+"&user_mobile="+encodeURIComponent(this.mobile)+"&sms_code="+encodeURIComponent(this.smsCode)}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){ //
                        self.stepOne = false;
                        self.stepTwo = true;
                        self.stepThree = false;
                    } else {
                        self.stepOneErrMsg = res.mess;
                        self.stepOneErrMsgShow = true;
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    self.stepOneErrMsg = "验证失败请稍后重试";
                    self.stepOneErrMsgShow = true;
                });
            },
            savePwdNew: function () {
                const self = this;
                if (this.newPwd == ''){
                    alert('请设置新密码');
                    return false;
				}
                //ajax 调用登录接口
                http({method: "post", url: "/user/upd-pwd-two", data: "user_mobile="+encodeURIComponent(this.mobile)+"&password="+encodeURIComponent(this.newPwd)}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){ //
                        self.stepOne = false;
                        self.stepTwo = false;
                        self.stepThree = true;
                        setTimeout(() => {
                            self.$router.push('/login');
						}, 2000);
                    } else {
                        alert(res.mess);
                        return false;
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
					alert("密码重置失败，请稍后重试");
					return false;
                });
            }

        },
        created(){

        },

    }

</script>
<style scoped>
    @import "//images.jinku.com/newjk/h5/css/global_mobile.css";
    @import "//images.jinku.com/newjk/h5/css/public.css";
    @import "//images.jinku.com/newjk/h5/css/find_psw.css";
</style>



// WEBPACK FOOTER //
// src/components/reset-pwd.vue